import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { bmxurl, getAccess } from 'src/globals';
import { users_returndata } from 'src/types/user_returndata';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-reportpage',
  templateUrl: './reportpage.component.html',
  styleUrls: ['./reportpage.component.css']
})
export class ReportpageComponent implements OnInit {

  ReportInfo: string = "";
  ShowPaymentReportButton: boolean = false;
  ShowCustomerReportButton: boolean = false;
  ShowExtrasReportButton: boolean = false;
  ShowBQReportButton: boolean = false;
  ShowBookingListReportButton: boolean = false;
  ShowBookingListCreatedReportButton: boolean = false;
  ShowSalesReportButton: boolean = false
  AccessAllowed: boolean = false; 
  CompletedLoading: boolean = true;
  httpResponse: any;

  constructor(
    private router: Router,
    private http: HttpClient,
    private messageService: MessageService
  ) 
  {}

  ngOnInit(): void {
  
      let userid = localStorage.getItem("SmartUserID");
  
      this.http.get(bmxurl + "User/" + userid).subscribe(response => {
        this.httpResponse =  (response as users_returndata)
        if(this.httpResponse.succeeded)
        {
          let user = this.httpResponse.data;
  
          if(getAccess("REPORTS", user)){
            this.AccessAllowed = true;
          }
  
          this.CompletedLoading = true;
  
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
      });
  }

  doPaymentsReport(){
    this.router.navigateByUrl("/paymentreport");
  }

  showPaymentText()
  {
    this.ShowReportButton("Payments");
    this.ReportInfo = "<h4>Payments Report</h4><br>The Payment Report shows all payments made between the dates chosen.  <BR><BR>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doCustomerReport(){
    this.router.navigateByUrl("/customerreport");
  }

  showCuwtomerText(){
    this.ShowReportButton("Customers");
    this.ReportInfo = "<h4>Customer Report</h4><br>The Customer Report shows a list of all customers who have ever visited the venue.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doExtrasReport(){
    this.router.navigateByUrl("/extrasreport");
  }

  showExtrasText(){
    this.ShowReportButton("Extras");
    this.ReportInfo = "<h4>Extras Report</h4><br>The Extras Report shows all Extras purchased by customers between the dates chosen. <br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doBQReport(){
    this.router.navigateByUrl("/bookinganswersreport");
  }

  showBQText(){
    this.ShowReportButton("BQ");
    this.ReportInfo = "<h4>Booking Questions Report</h4><br>The Booking Questions Report shows all booking questions for bookings between the dates chosen.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doBookingListReport(){
    this.router.navigateByUrl("/bookinglistreport");
  }

  showBLText(){
    this.ShowReportButton("BookingList");
    this.ReportInfo = "<h4>Booking List Report</h4><br>The Booking List Report shows all bookings between the dates chosen.  The report gives you a break down of the admissions, extras and allergies for the bookings.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doBookingListCreatedReport(){
    this.router.navigateByUrl("/bookinglistcreatedreport");
  }

  showBLCText(){
    this.ShowReportButton("BookingListCreated");
    this.ReportInfo = "<h4>Booking List Report (Created Date)</h4><br>The Booking List Report (Created Date) shows all bookings created between the dates chosen.  The report gives you a break down of the admissions, extras and allergies for the bookings.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  doSalesReport(){
    this.router.navigateByUrl("/salesreport");
  }

  showSalesText(){
    this.ShowReportButton("Sales");
    this.ReportInfo = "<h4>Sales Report</h4><br>The Sales Report gives you a list of all bookings sub totaled by package.<br><br>Reports can be exported to CSV/Excel format by clicking on the export button at the top of the report.";
  }

  ShowReportButton(requiredReport: string){
    this.ShowPaymentReportButton = false;
    this.ShowCustomerReportButton = false;
    this.ShowExtrasReportButton = false;
    this.ShowBQReportButton = false;
    this.ShowBookingListReportButton = false;
    this.ShowBookingListCreatedReportButton = false;
    this.ShowSalesReportButton = false;

    if (requiredReport == "Payments"){
      this.ShowPaymentReportButton = true;
    }

    if (requiredReport == "Customers"){
      this.ShowCustomerReportButton = true;
    }

    if (requiredReport == "Extras"){
      this.ShowExtrasReportButton = true;
    }

    if (requiredReport == "BQ"){
      this.ShowBQReportButton = true;
    } 

    if (requiredReport == "BookingList"){
      this.ShowBookingListReportButton = true;
    }

    if (requiredReport == "BookingListCreated"){
      this.ShowBookingListCreatedReportButton = true;
    }

    if (requiredReport == "Sales"){
      this.ShowSalesReportButton = true;
    }
  }
}


